import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';

type Props = {
  name: string;
};

export const EmptyState: FC<Props> = ({ name }) => {
  const t = useTranslations('people.details.assessment.emptyState');

  return (
    <Box mt='s' data-testid='empty-state-no-user-credits' textAlign='center'>
      <Typography variant='h1' mb='xs'>
        {t('title')}
      </Typography>
      <Typography variant='p3/light'>{t('description', { name })}</Typography>
    </Box>
  );
};
